import type { PartialDeep } from 'type-fest';
import Log from '../../common/logging';
import { Configuration } from '../defaultConfig';

const loadDynamicConfig = (): PartialDeep<Configuration> => {
  // Try and load the data from the dynamic config json file. Return empty data on failure.
  try {
    // eslint-disable-next-line import/no-dynamic-require,global-require,import/no-unresolved
    return require('./dynamicConfig.json');
  } catch (error) {
    Log.debug('No dynamic configuration loaded. Generate dynamic config with command: yarn dynamic-config');
  }
  return {};
};

export default loadDynamicConfig;
